import { connect } from 'react-redux';
import { breakpointSelector } from 'selectors/breakpoint';
import ToolTip from './ToolTip';

const mapStateToProps = (state) => ({ breakpoint: breakpointSelector(state) });

export default connect(mapStateToProps)(ToolTip);
